import { render, staticRenderFns } from "./RmOrderItemBatchUpdatePopUp.vue?vue&type=template&id=3a1a21ff&scoped=true&"
import script from "./RmOrderItemBatchUpdatePopUp.vue?vue&type=script&lang=js&"
export * from "./RmOrderItemBatchUpdatePopUp.vue?vue&type=script&lang=js&"
import style0 from "./RmOrderItemBatchUpdatePopUp.vue?vue&type=style&index=0&id=3a1a21ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1a21ff",
  null
  
)

export default component.exports